<script>
  import Hydrograph from './Hydrograph.svelte'

  export let lid
  export let chartName
  export let gauge = null // added for Chrome warning
  export let reachID = null // added for Chrome warning
  export let gaugeConfig // gauge configuration
  export let assetURL = ''
  export let ratings = null // added for Chrome warning
  export let stageflow = null // added for Chrome warning
  export let view
</script>

<Hydrograph {view} {lid} {reachID} {chartName} {ratings} {gauge} {stageflow} {assetURL} {gaugeConfig} />

<style>
  :global(#gauge-app) {
    color: #000;
  }
  :global(.probability-info-card > div) {
    padding-bottom: 0 !important;
  }
</style>
